<template>
  <SingleClass />
</template>

<script>
import SingleClass from '@/components/content/classes/EditSelectedClass.vue'

export default {
  name: 'ContentClass',
  components: { SingleClass }
}
</script>

<style scoped>

</style>
